'use strict';

var durationCtrl = ['BuilderDataService',function(BuilderDataService) {
    var _this = this;

    _this.getElements = function() {
        return BuilderDataService.getElements(this.element.templateData.dateComparisonType,this.element);
    };

}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            form: '='
        },
        controller: durationCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/durationDirective.html'
    };
};
